import React from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { usePopup } from "../context/PopupContext";
import SignupForm from "./SignupForm";

export const PopupForm = () => {
  const { open, setOpen } = usePopup();
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="max-h-[94vh] w-[calc(100vw-1.5rem)] max-w-[460px] overflow-hidden border-0 bg-transparent p-0 shadow-none sm:max-w-[460px] sm:rounded-none"
        data-testid="popup-form-dialog"
      >
        <SignupForm testIdPrefix="popup" compact />
      </DialogContent>
    </Dialog>
  );
};

export default PopupForm;
